var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInactivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30ZM23.4784 18.261C23.4784 20.4221 21.9211 22.174 20.0001 22.174C18.0791 22.174 16.5218 20.4221 16.5218 18.261C16.5218 16.0999 18.0791 14.348 20.0001 14.348C21.9211 14.348 23.4784 16.0999 23.4784 18.261ZM25.9553 25.3419C24.4907 26.9737 22.3652 28.0001 20 28.0001C17.6348 28.0001 15.5093 26.9737 14.0447 25.342C15.5887 23.8557 17.6877 22.9418 20.0001 22.9418C22.3124 22.9418 24.4113 23.8557 25.9553 25.3419Z",
    fill: "#FFC79C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.841 23.409C25.9623 22.5303 24.5377 22.5303 23.659 23.409C22.7803 24.2877 22.7803 25.7123 23.659 26.591L24.568 27.5L23.659 28.409C22.7803 29.2877 22.7803 30.7123 23.659 31.591C24.5377 32.4697 25.9623 32.4697 26.841 31.591L27.75 30.682L28.659 31.591C29.5377 32.4697 30.9623 32.4697 31.841 31.591C32.7197 30.7123 32.7197 29.2877 31.841 28.409L30.932 27.5L31.841 26.591C32.7197 25.7123 32.7197 24.2877 31.841 23.409C30.9623 22.5303 29.5377 22.5303 28.659 23.409L27.75 24.318L26.841 23.409Z",
    fill: "#FFC79C",
    stroke: "#FFF4E4",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInactivity);
export default __webpack_public_path__ + "static/media/notification-inactivity.2b8dab6094b54a77e0024f7c0ad7d641.svg";
export { ForwardRef as ReactComponent };